import { BdsFloatingActionBar, BdsRollupButton } from "@buildertrend/components";

export interface IBillApprovalQueueFloatingActionBarProps {
    selectedCount: number;
    onDeselect: () => void;
    onApprove: () => void;
    disabled: boolean;
}

export function BillApprovalQueueFloatingActionBar(
    props: IBillApprovalQueueFloatingActionBarProps,
) {
    const { selectedCount, onDeselect, onApprove, disabled } = props;

    return (
        <BdsFloatingActionBar
            testid="billApprovalQueueActionBar"
            selectedCount={selectedCount}
            onDeselect={onDeselect}
            primaryActions={
                <BdsRollupButton
                    id="bulkApprove"
                    testid="bulkApprove"
                    text="Approve"
                    value="approve"
                    disabled={disabled}
                    onClick={onApprove}
                />
            }
        />
    );
}
